<template>
  <div class="div">
    <div class="main-container">
      <div class="left-panel">
        <!-- 设备总览 -->
        <el-card
          class="section-card device-overview"
          v-loading="HomepageStatisticsLoading"
          style="height: 270px"
        >
          <div class="section-title">设备总览</div>
          <div class="overview-content">
            <div class="sales-card green-card">
              <div class="card-text">
                <div class="card-icon">￥</div>
                LCC(设备全程期成本)
              </div>
              <div class="card-value">
                <!-- <div>设备总价值</div> -->
                <div>
                  {{ $tools.formatThousand(HomepageStatisticsInfo.totalCost, 2) }}
                </div>
              </div>
              <div class="card-growth">
                <div>设备购置成本</div>
                <div>
                  {{ $tools.formatThousand(HomepageStatisticsInfo.AcquisitionCost, 2) }}
                </div>
              </div>
              <div class="card-footer"></div>
            </div>
            <div class="right-overview-cards">
              <div class="small-card">
                <div class="card-text">
                  <span class="bold-text"
                    ><i
                      class="icon-shebei icon"
                      style="color: #e6a23c; font-size: 20px; margin-right: 5px"
                    ></i>
                    设备总数</span
                  >（单位：台）
                </div>
                <div class="card-value">
                  {{ HomepageStatisticsInfo.DeviceCount || 0 }}
                </div>
              </div>
              <div class="small-card">
                <div class="card-text">
                  <span class="bold-text">
                    <i
                      class="icon-yunhangzhong icon"
                      style="color: #67c23a; font-size: 20px; margin-right: 5px"
                    ></i
                    >开机中</span
                  >（单位：台）
                </div>
                <div class="card-value">
                  {{ HomepageStatisticsInfo.PowerOn || 0 }}
                </div>
              </div>
              <div class="small-card">
                <div class="card-text">
                  <span class="bold-text">
                    <i
                      class="icon-tingzhizhong1 icon"
                      style="color: #f56c6c; font-size: 20px; margin-right: 5px"
                    ></i
                    >停机中</span
                  >（单位：台）
                </div>
                <div class="card-value">
                  {{ HomepageStatisticsInfo.PowerOff || 0 }}
                </div>
              </div>
              <div class="small-card">
                <div class="card-text">
                  <span class="bold-text"
                    ><i
                      class="icon-tingzhizhong icon"
                      style="color: #e6a23c; font-size: 20px; margin-right: 5px"
                    ></i
                    >故障中</span
                  >（单位：台）
                </div>
                <div class="card-value">
                  {{ HomepageStatisticsInfo.FaultNum || 0 }}
                </div>
              </div>
              <!-- <div class="small-card">
                <div class="card-text">本年运维成本</div>
                <div class="card-value">
                  {{
                    $tools.formatThousand(
                      HomepageStatisticsInfo.OperationCost,
                      2
                    )
                  }}
                </div>
              </div>
              <div class="small-card">
                <div class="card-text">设备成新率</div>
                <div class="card-value">
                  {{ HomepageStatisticsInfo.NewnessRate }}%
                </div>
              </div> -->
              <div class="small-card">
                <div class="card-text">
                  <img
                    src="@/assets/shui.png"
                    alt=""
                    style="width: 20px; height: 20px; margin-right: 10px"
                  />
                  <span class="bold-text">水耗</span> （单位：元）
                </div>
                <div class="card-value">
                  {{ $tools.formatThousand(HomepageStatisticsInfo.Water, 2) }}
                </div>
              </div>
              <div class="small-card">
                <div class="card-text">
                  <img
                    src="@/assets/dian.png"
                    alt=""
                    style="width: 20px; height: 20px; margin-right: 10px"
                  />
                  <span class="bold-text">电耗</span> （单位：元）
                </div>
                <div class="card-value">
                  {{ $tools.formatThousand(HomepageStatisticsInfo.Electricity, 2) }}
                </div>
              </div>
              <div class="small-card">
                <div class="card-text">
                  <img
                    src="@/assets/qi.png"
                    alt=""
                    style="width: 20px; height: 20px; margin-right: 10px"
                  />
                  <span class="bold-text">气耗</span> （单位：元）
                </div>
                <div class="card-value">
                  {{ $tools.formatThousand(HomepageStatisticsInfo.Gas, 2) }}
                </div>
              </div>
              <div class="small-card">
                <div class="card-text">
                  <img
                    src="@/assets/you.png"
                    alt=""
                    style="width: 20px; height: 20px; margin-right: 10px"
                  />
                  <span class="bold-text">油耗</span> （单位：元）
                </div>
                <div class="card-value">
                  {{ $tools.formatThousand(HomepageStatisticsInfo.Oil, 2) }}
                </div>
              </div>
            </div>
          </div>
        </el-card>
        <el-card
          class="section-card inspection-maintenance"
          v-loading="CompletePeriodLoading"
        >
          <div class="section-title df aic jub">
            <span>全周期成本</span>
            <span class="hint-text">
              全周期成本（累计值） =（原值+维保+备件+能耗） 单位：（元）
            </span>
          </div>
          <EchartsDom
            type="bar2"
            :data="CompletePeriodInfo || []"
            :is-stack="true"
            barWidth="40%"
            legendTop="5px"
            :thousandSeparator="true"
            :grid="{
              left: 120,
              right: 40,
              bottom: 20,
              top: 40,
            }"
            width="100%"
            height="200px"
          />
        </el-card>

        <!-- 运行情况 -->
        <el-card class="section-card operational-status" v-loading="HomepageRunLoading">
          <div class="section-title">故障分析(最近12个月)</div>
          <div class="status-content" style="position: relative">
            <EchartsDom
              type="bar2"
              :data="yearChartsInfo.yearFaultObjList || []"
              title="故障分析"
              :grid="{
                left: 60,
                top: 65,
                right: 40,
                bottom: 20,
              }"
              legendTop="30px"
              width="60%"
              height="100%"
              legendType="scroll"
              labelPosition="inside"
            />
            <el-divider direction="vertical" class="divider"></el-divider>
            <EchartsDom
              type="pie"
              :data="yearChartsInfo.faultobjlist || []"
              title="故障分类"
              width="40%"
              height="100%"
              legendType="scroll"
              legendPosition="left"
              legendLeft="10px"
              v-if="radio1 === '1'"
            />
            <EchartsDom
              type="pie"
              :data="yearChartsInfo.devicetypeobjlist || []"
              title="设备分类"
              width="40%"
              height="100%"
              legendPosition="left"
              legendLeft="10px"
              v-if="radio1 === '2'"
            />
            <el-radio-group v-model="radio1" style="position: absolute; right: 0; top: 0">
              <el-radio-button label="1">故障分类</el-radio-button>
              <el-radio-button label="2">设备分类</el-radio-button>
            </el-radio-group>
          </div>
        </el-card>

        <!-- 工单信息 -->
        <el-card class="section-card inspection-maintenance">
          <div class="section-title">
            <span>运维情况</span>
            <el-radio-group v-model="day" style="margin-left: 20px" @change="dayChange">
              <el-radio-button label="10">近10天</el-radio-button>
              <el-radio-button label="20">近20天</el-radio-button>
              <el-radio-button label="30">近30天</el-radio-button>
            </el-radio-group>
          </div>
          <div class="WorkOrder-card" v-loading="WorkOrderLoading">
            <div class="right-overview-cards">
              <div class="small-card">
                <div class="card-text">工单量</div>
                <div class="card-value">
                  {{ WorkOrderInfo.total || 0 }}
                </div>
              </div>
              <div class="small-card">
                <div class="card-text">完成率</div>
                <div class="card-value">{{ WorkOrderInfo.rate || 0 }}%</div>
              </div>
              <div class="small-card">
                <div class="card-text">平均完成时长（小时）</div>
                <div class="card-value">
                  {{ WorkOrderInfo.avg || 0 }}
                </div>
              </div>
            </div>
          </div>
          <el-tabs
            v-model="cardActiveName"
            type="card"
            style="margin-top: 20px"
            @tab-click="handleTabClick"
          >
            <el-tab-pane label="巡检" name="巡检"> </el-tab-pane>
            <el-tab-pane label="保养" name="保养"> </el-tab-pane>
            <el-tab-pane label="维修" name="维修"> </el-tab-pane>
          </el-tabs>
          <div class="w100 df aic">
            <div
              style="
                width: calc(100%);
                text-align: center;
                font-size: 18px;
                font-weight: bold;
              "
            >
              {{ activeNameTitle[0] || "" }}
            </div>
            <el-select
              v-model="activeName"
              placeholder="请选择"
              style="width: 200px"
              @change="getHomepageInspectionAndMaintenance"
            >
              <!-- <el-option label="巡检累计人次" value="1"> </el-option> -->
              <el-option label="巡检次数" value="4" v-if="cardActiveName === '巡检'">
              </el-option>
              <el-option
                label="各专业巡检频次"
                value="2"
                v-if="cardActiveName === '巡检'"
              >
              </el-option>
              <el-option
                label="各类型巡检频次"
                value="3"
                v-if="cardActiveName === '巡检'"
              >
              </el-option>
              <el-option
                label="各专业保养频次"
                value="5"
                v-if="cardActiveName === '保养'"
              >
              </el-option>
              <el-option
                label="各类型保养频次"
                value="6"
                v-if="cardActiveName === '保养'"
              >
              </el-option>
              <el-option
                label="各专业维修频次"
                value="7"
                v-if="cardActiveName === '维修'"
              >
              </el-option>
              <el-option
                label="各类型维修频次"
                value="8"
                v-if="cardActiveName === '维修'"
              >
              </el-option>
            </el-select>
          </div>
          <!-- :title="activeNameTitle[0] || ''" -->
          <EchartsDom
            v-loading="HomepageInspectionAndMaintenanceLoading"
            type="bar"
            :data="WorkOrderDataInfo || []"
            width="100%"
            :grid="{
              left: 60,
              top: 30,
              right: 40,
              bottom: 20,
            }"
            height="180px"
            legendType="scroll"
            :yAxisName="activeNameTitle[1] || ''"
            labelPosition="inside"
          />
        </el-card>
        <!-- 备件信息 -->
        <el-card class="section-card inspection-maintenance">
          <div class="section-title df jub">
            <span>
              <span>备件库存</span>
              <el-radio-group
                v-model="MaterialInventoryInType"
                style="margin-left: 20px; font-size: 12px"
                @change="MaterialInventoryInTypeChange"
              >
                <el-radio-button label="Amount"
                  ><i class="icon icon-rmb1" style="font-size: 14px"></i>
                  金额</el-radio-button
                >
                <el-radio-button label="Qty">
                  <i class="icon icon-num" style="font-size: 14px"></i>
                  数量</el-radio-button
                >
              </el-radio-group>
            </span>
          </div>
          <div class="WorkOrder-card" v-loading="WorkOrderLoading">
            <div class="right-overview-cards">
              <div class="small-card" v-loading="MaterialInventoryInLoading">
                <div class="card-text">
                  <span class="bold-text">当前库存</span>
                  <span v-if="MaterialInventoryInType === 'Amount'">（单位：元）</span>
                  <span v-if="MaterialInventoryInType === 'Qty'">（单位：件）</span>
                </div>
                <div class="card-value">
                  <span v-if="MaterialInventoryInType === 'Qty'">{{
                    $tools.formatThousand(MaterialInventoryInInfo.tNum, 0) || 0
                  }}</span>
                  <span v-if="MaterialInventoryInType === 'Amount'">{{
                    $tools.formatThousand(MaterialInventoryInInfo.tAmount, 2) || 0
                  }}</span>
                </div>
              </div>
              <div class="small-card" v-loading="MaterialInventoryInPutLoading">
                <div class="card-text">
                  <span class="bold-text">累计入库(最近12个月)</span>
                  <span v-if="MaterialInventoryInType === 'Amount'">（单位：元）</span>
                  <span v-if="MaterialInventoryInType === 'Qty'">（单位：件）</span>
                </div>
                <div class="card-value">
                  <span v-if="MaterialInventoryInType === 'Qty'">{{
                    $tools.formatThousand(MaterialInventoryInInfoPut.tNum, 0) || 0
                  }}</span>
                  <span v-if="MaterialInventoryInType === 'Amount'">{{
                    $tools.formatThousand(MaterialInventoryInInfoPut.tAmount, 2) || 0
                  }}</span>
                </div>
              </div>
              <div class="small-card" v-loading="MaterialInventoryInOutLoading">
                <div class="card-text">
                  <span class="bold-text">累计出库(最近12个月)</span>
                  <span v-if="MaterialInventoryInType === 'Amount'">（单位：元）</span>
                  <span v-if="MaterialInventoryInType === 'Qty'">（单位：件）</span>
                </div>
                <div class="card-value">
                  <span v-if="MaterialInventoryInType === 'Qty'">{{
                    $tools.formatThousand(MaterialInventoryInInfoOut.tNum, 0) || 0
                  }}</span>
                  <span v-if="MaterialInventoryInType === 'Amount'">{{
                    $tools.formatThousand(MaterialInventoryInInfoOut.tAmount, 2) || 0
                  }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="WorkOrder-card" v-loading="WorkOrderLoading">
            <div class="right-overview-cards">
              <div class="df" style="width: 100%; position: relative; height: 220px">
                <EchartsDom
                  type="pie"
                  :data="MaterialInventoryInInfo.blist || []"
                  legendPosition="bottom"
                  title="库存分布"
                  style="width: 100%; height: 220px; margin-top: 20px"
                  :showLegend="false"
                  :thousandSeparator="true"
                  :decimalPlaces="MaterialInventoryInType === 'Qty' ? 0 : 2"
                  v-loading="MaterialInventoryInLoading"
                ></EchartsDom>
                <el-divider direction="vertical" class="divider ec"></el-divider>
              </div>
              <div class="df" style="width: 100%; position: relative; height: 220px">
                <EchartsDom
                  type="pie"
                  :data="MaterialInventoryInInfoPut.blist || []"
                  legendPosition="bottom"
                  title="入库分布"
                  style="width: 100%; height: 220px; margin-top: 20px"
                  :showLegend="false"
                  :thousandSeparator="true"
                  :decimalPlaces="MaterialInventoryInType === 'Qty' ? 0 : 2"
                  v-loading="MaterialInventoryInPutLoading"
                ></EchartsDom>
                <el-divider direction="vertical" class="divider ec"></el-divider>
              </div>
              <div class="df" style="width: 100%; position: relative; height: 220px">
                <EchartsDom
                  type="pie"
                  :data="MaterialInventoryInInfoOut.blist || []"
                  legendPosition="bottom"
                  title="出库分布"
                  :thousandSeparator="true"
                  :decimalPlaces="MaterialInventoryInType === 'Qty' ? 0 : 2"
                  style="width: 100%; height: 220px; margin-top: 20px"
                  :showLegend="false"
                  v-loading="MaterialInventoryInOutLoading"
                ></EchartsDom>
              </div>
            </div>
          </div>
        </el-card>
        <!-- 能耗信息 -->
        <el-card class="section-card inspection-maintenance">
          <div class="section-title">
            <span>能耗信息（最近12个月）</span>
            <el-radio-group
              v-model="EnergycType"
              style="margin-left: 20px"
              @change="getEnergycInfo"
            >
              <el-radio-button label="Amount"
                ><i class="icon icon-rmb1" style="font-size: 14px"></i>
                金额</el-radio-button
              >
              <el-radio-button label="Qty">
                <i class="icon icon-num" style="font-size: 14px"></i>
                耗用量</el-radio-button
              >
            </el-radio-group>
          </div>
          <div class="WorkOrder-card" v-loading="EnergycLoading">
            <div class="right-overview-cards4">
              <div class="small-card" v-for="item in EnergycInfo?.list" :key="item.Name">
                <div class="card-text">
                  <img
                    :src="
                      item.name === '水'
                        ? require('@/assets/shui.png')
                        : item.name === '电'
                        ? require('@/assets/dian.png')
                        : item.name === '气'
                        ? require('@/assets/qi.png')
                        : item.name === '油'
                        ? require('@/assets/you.png')
                        : ''
                    "
                    alt=""
                    style="width: 20px; height: 20px; margin-right: 10px"
                  />
                  <span class="bold-text">{{ item.name }}耗 </span> （单位：{{
                    EnergycType === "Qty"
                      ? item.name === "水"
                        ? "方"
                        : item.name === "电"
                        ? "度"
                        : item.name === "气"
                        ? "方"
                        : "升"
                      : "元"
                  }}）
                </div>
                <div class="card-value">
                  <span v-if="EnergycType === 'Qty'">{{
                    $tools.formatThousand(item.value.Qty, 0) || 0
                  }}</span>
                  <span v-if="EnergycType === 'Amount'">{{
                    $tools.formatThousand(item.value.Amount || 0, 2)
                  }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="WorkOrder-card" v-loading="EnergycLoading">
            <div class="right-overview-cards4">
              <div
                class="df"
                style="width: 100%; position: relative"
                v-for="(item, index) in EnergycInfo?.blist"
                :key="item.name"
              >
                <EchartsDom
                  type="pie"
                  :data="item.value || []"
                  :thousandSeparator="true"
                  :decimalPlaces="EnergycType === 'Qty' ? 0 : 2"
                  legendPosition="bottom"
                  :title="item.name + '耗分布'"
                  style="width: 100%; height: 220px; margin-top: 20px"
                  :showLegend="false"
                ></EchartsDom>
                <el-divider
                  direction="vertical"
                  class="divider ec"
                  v-if="index !== EnergycInfo?.blist?.length - 1"
                ></el-divider>
              </div>
            </div>
          </div>
        </el-card>
        <!-- 全周期成本 -->

        <div style="height: 50px"></div>
      </div>

      <div class="right-panel">
        <!-- 成本总览 -->
        <div
          class="section-card cost-overview"
          style="height: 270px; padding: 0; position: relative"
        >
          <div class="projectInfo">
            <div style="flex: 1" class="ellipsis2">{{ ProjectInfo.Name || "" }}</div>
            <div style="flex: 1" class="ellipsis2">
              建筑面积：{{ ProjectInfo.TotalArea || "" }}㎡
            </div>
          </div>
        
          <el-image
            :src="ProjectInfo.ProjectImg||''"
             @error="handleImageError"
            fit="cover"
            :key="ProjectInfo.ProjectImg"
            style="width: 100%; height: calc(100% - 40px); border-radius: 8px"
          ></el-image>
        </div>
        <!-- 楼栋停开机 -->
        <el-card
          class="section-card operational-status"
          v-loading="HomepageStatisticsLoading"
        >
          <div class="section-title df jub">
            <span>设备开停机状态（实时更新-最新）</span>
            <span class="hint-text">单位：（台）</span>
          </div>
          <el-table
            :data="HomepageStatisticsInfo.list"
            style="width: 100%; min-height: 240px"
            stripe
            header-row-class-name="table-tit"
            row-class-name="table-row"
          >
            <el-table-column label="楼栋" prop="BuildingName"></el-table-column>
            <el-table-column
              label="开机数（台）"
              prop="oNum"
              align="right"
            ></el-table-column>
            <el-table-column
              label="停机数（台）"
              prop="sNum"
              align="right"
            ></el-table-column>
          </el-table>
        </el-card>
        <el-card
          class="section-card operational-status"
          v-loading="HomepageStatisticsLoading"
        >
          <div class="section-title df jub">
            <span>设备故障状态（实时更新-最新）</span>
            <span class="hint-text">单位：（台）</span>
          </div>

          <el-table
            :data="HomepageStatisticsInfo.falist"
            stripe
            style="width: 100%; min-height: 240px"
          >
            <el-table-column label="楼栋" prop="BuildingName"></el-table-column>
            <el-table-column
              label="故障数（台）"
              prop="oNum"
              align="right"
            ></el-table-column>
            <el-table-column
              label="故障时长（小时）"
              prop="sNum"
              align="right"
            ></el-table-column>
          </el-table>
        </el-card>
        <div class="section-card cost-overview">
          <div class="section-title df jub">
            <span>成本总览（最近12个月）</span>
            <span class="hint-text">单位：（元）</span>
          </div>
          <div class="cost-details">
            <div class="sales-yoy">
              <div class="item">
                <div class="label">能耗成本</div>
                <div class="value">
                  {{ $tools.formatThousand(HomepageCostInfo.TconsumptionCost, 2) }}
                </div>
              </div>
              <div class="item">
                <div class="label">保养成本</div>
                <div class="value">
                  {{ $tools.formatThousand(HomepageCostInfo.OperationCost, 2) }}
                </div>
              </div>
            </div>
            <div class="category-list">
              <div
                class="category-item"
                v-for="(item, index) in HomepageCostInfo.devicetypecost"
                :key="item.Name"
              >
                <div class="rank">{{ index + 1 }}</div>
                <div class="name">{{ item.Name }}</div>
                <div class="progress-container">
                  <div
                    class="progress-bar"
                    :style="{
                      width:
                        (item.Amout / HomepageCostInfo.devicetypecost[0]?.Amout) * 100 +
                        '%',
                    }"
                  ></div>
                </div>
                <div class="value">
                  {{ $tools.formatThousand(item.Amout, 2) }}
                </div>
              </div>
              <div style="height: 13px"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EchartsDom from "@/components/EchartsDom/EchartsDom.vue";
import moment from "moment";
export default {
  components: {
    EchartsDom,
  },
  name: "HomeInfo",
  data() {
    return {
      HomepageCostLoading: false,
      HomepageCostInfo: {},
      HomepageStatisticsLoading: false,
      HomepageStatisticsInfo: {},
      HomepageRunLoading: false,
      yearChartsInfo: {},
      radio1: "1",

      WorkOrderInfo: {},
      WorkOrderLoading: false,
      day: "30",
      cardActiveName: "巡检",
      activeName: "4",
      WorkOrderDataInfo: [],

      EnergycInfo: {
        blist: [],
        list: [],
      },
      EnergycLoading: false,
      EnergycType: "Amount",

      CompletePeriodLoading: false,
      CompletePeriodInfo: [],
      HomepageInspectionAndMaintenanceLoading: false,
      MaterialInventoryInType: "Amount",
      MaterialInventoryInLoading: false,
      MaterialInventoryInInfo: {},
      MaterialInventoryInPutLoading: false,
      MaterialInventoryInInfoPut: {},
      MaterialInventoryInOutLoading: false,
      MaterialInventoryInInfoOut: {},
      ProjectInfo: {
        Name:"",
        TotalArea:"",
        ProjectImg:""
      },
    };
  },
  props: {},
  emits: [],
  computed: {
    sortedDeviceList() {
      return [...this.deviceList].sort((a, b) => b.value - a.value);
    },
    maxValue() {
      return Math.max(...this.deviceList.map((item) => item.value));
    },
    activeNameTitle() {
      let tabName = this.activeName;
      let title = "";
      let yAxisStr = "";
      if (tabName === "1") {
        title = "巡检累计人次";
        yAxisStr = "人次";
      } else if (tabName === "2") {
        title = "各专业巡检频次";
        yAxisStr = "次数";
      } else if (tabName === "3") {
        title = "各类型巡检频次";
        yAxisStr = "次数";
      } else if (tabName === "4") {
        title = "巡检次数";
        yAxisStr = "次数";
      } else if (tabName === "5") {
        title = "各专业保养频次";
        yAxisStr = "次数";
      } else if (tabName === "6") {
        title = "各类型保养频次";
        yAxisStr = "次数";
      } else if (tabName === "7") {
        title = "各专业维修频次";
        yAxisStr = "次数";
      } else if (tabName === "8") {
        title = "各类型维修频次";
        yAxisStr = "次数";
      }
      return [title, yAxisStr];
    },
  },
  watch: {
    activeName(newVal) {
      this.$nextTick(() => {
        this.getHomepageInspectionAndMaintenance(newVal);
      });
    },
  },
  methods: {
    handleImageError(e) {
    console.log(e)
    console.log(this.ProjectInfo.ProjectImg)
    },
    
    getCompletePeriod() {
      this.CompletePeriodLoading = true;
      this.$http.post(`/PB/PB_Project/LifeCycleCostCalculator`, {}).then((res) => {
        this.CompletePeriodLoading = false;
        if (res.Success) {
          this.CompletePeriodInfo = res.Data || [];
        } else {
          this.$notify.error(res.Msg);
        }
      });
    },

    getEnergycInfo() {
      this.EnergycLoading = true;
      this.$http
        .post(
          `/PB/PB_Project/GetEnergycYearSummaryAnalysis?iYear=${moment().format(
            "YYYY"
          )}&type=${this.EnergycType}`,
          {}
        )
        .then((res) => {
          this.EnergycLoading = false;
          if (res.Success) {
            this.EnergycInfo = res.Data;
          } else {
            this.$notify.error(res.Msg);
          }
        });
    },
    // 备件金额数量切换
    MaterialInventoryInTypeChange() {
      this.getMaterialInventoryIn();
      this.getMaterialInventoryInPut();
      this.getMaterialInventoryInOut();
    },
    //备件库存
    getMaterialInventoryIn() {
      this.MaterialInventoryInLoading = true;
      this.$http
        .post(
          `/PB/PB_Project/MaterialInventoryAnalysis?type=${
            this.MaterialInventoryInType
          }&yearMonth=${moment().format("YYYY")}`,
          {}
        )
        .then((res) => {
          this.MaterialInventoryInLoading = false;
          if (res.Success) {
            this.MaterialInventoryInInfo = res.Data;
          } else {
            this.$notify.error(res.Msg);
          }
        });
    },
    //备件入库
    getMaterialInventoryInPut() {
      this.MaterialInventoryInPutLoading = true;
      this.$http
        .post(
          `/PB/PB_Project/MaterialInventoryInStorAnalysis?type=${
            this.MaterialInventoryInType
          }&iyear=${moment().format("YYYY")}`,
          {}
        )
        .then((res) => {
          this.MaterialInventoryInPutLoading = false;
          if (res.Success) {
            this.MaterialInventoryInInfoPut = res.Data;
          } else {
            this.$notify.error(res.Msg);
          }
        });
    },
    //备件出库
    getMaterialInventoryInOut() {
      this.MaterialInventoryInOutLoading = true;
      this.$http
        .post(
          `/PB/PB_Project/MaterialInventoryOutStorAnalysis?type=${
            this.MaterialInventoryInType
          }&iyear=${moment().format("YYYY")}`,
          {}
        )
        .then((res) => {
          this.MaterialInventoryInOutLoading = false;
          if (res.Success) {
            this.MaterialInventoryInInfoOut = res.Data;
          } else {
            this.$notify.error(res.Msg);
          }
        });
    },
    //本年度成本总览
    getHomepageCost() {
      this.HomepageCostLoading = true;
      this.$http.post("/PB/PB_Project/HomepageCost", {}).then((res) => {
        this.HomepageCostLoading = false;
        if (res.Success) {
          this.HomepageCostInfo = res.Data;
        } else {
          this.$notify.error(res.Msg);
        }
      });
    },
    //设备总览+楼栋停开机
    getHomepageStatistics() {
      this.HomepageStatisticsLoading = true;
      this.$http.post("/PB/PB_Project/HomepageStatistics", {}).then((res) => {
        this.HomepageStatisticsLoading = false;
        if (res.Success) {
          this.HomepageStatisticsInfo = res.Data;
        } else {
          this.$notify.error(res.Msg);
        }
      });
    },
    //运行情况
    getHomepageRun() {
      this.HomepageRunLoading = true;
      this.$http.post("/PB/PB_Project/HomepageRun").then((res) => {
        this.HomepageRunLoading = false;
        if (res.Success) {
          this.yearChartsInfo = res.Data;
        } else {
          this.$notify.error(res.Msg);
        }
      });
    },
    //工单量完成率平均时长
    getWorkOrder() {
      this.WorkOrderLoading = true;
      this.$http
        .post(`/PB/PB_Project/GetDeviceWorkOrderStatistics?day=${this.day}`)
        .then((res) => {
          this.WorkOrderLoading = false;
          if (res.Success) {
            this.WorkOrderInfo = res.Data;
          } else {
            this.$notify.error(res.Msg);
          }
        });
    },
    //工单信息天数切换
    dayChange() {
      this.getWorkOrder();
      this.getHomepageInspectionAndMaintenance();
    },
    //工单信息
    getHomepageInspectionAndMaintenance() {
      this.HomepageInspectionAndMaintenanceLoading = true;
      this.$http
        .post(
          `/PB/PB_Project/HomepageInspectionAndMaintenance?Type=${this.activeName}&day=${this.day}`,
          {}
        )
        .then((res) => {
          this.HomepageInspectionAndMaintenanceLoading = false;
          if (res.Success) {
            this.WorkOrderDataInfo = res.Data || [];
          } else {
            this.$notify.error(res.Msg);
          }
        });
    },
    handleTabClick(tab) {
      if (tab.name === "保养") {
        this.activeName = "5";
      } else if (tab.name === "维修") {
        this.activeName = "7";
      } else {
        this.activeName = "4";
      }
      this.getHomepageInspectionAndMaintenance();
    },
    getProjectInfo() {
      this.$http
        .post(
          '/Base_Manage/Home/GetProjectInfo?ProjectId=' + this.$ProjectId,
          {}
        )
        .then((res) => {
          if (res.Success) {
            this.ProjectInfo = res.Data
            window.localStorage.setItem('ProjectInfo', JSON.stringify(res.Data))
          }
        })
    },
  },
  // 生命周期钩子
  beforeCreate() {},
  created() {
    if (localStorage.getItem("ProjectInfo")) {
      this.ProjectInfo = JSON.parse(localStorage.getItem("ProjectInfo"));
      console.log(this.ProjectInfo,'22222222222')
    }else{
      this.getProjectInfo()
    }

  },
  beforeMount() {},
  mounted() {
    this.getHomepageStatistics();
    this.getHomepageRun();
    this.getHomepageCost();
    this.getWorkOrder();
    this.getHomepageInspectionAndMaintenance(this.activeName);
    this.getMaterialInventoryIn();
    this.getMaterialInventoryInPut();
    this.getMaterialInventoryInOut();
    this.getEnergycInfo();
    this.getCompletePeriod();
   
   
    
  },
  beforeUpdate() {},
  updated() {},

  unmounted() {},
  // eslint-disable-next-line no-unused-vars
  errorCaptured(_err, _vm, _info) {
    return false;
  },
};
</script>

<style lang="scss" scoped>
.div {
  font-family: Arial, sans-serif;
  padding: 20px;
  background-color: #f0f2f5;
  overflow-y: auto;
}

.main-container {
  display: flex;
  gap: 10px;
}

.left-panel {
  flex: 3; /* Adjust flex basis to match image proportions */
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.right-panel {
  flex: 1; /* Adjust flex basis to match image proportions */
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.section-card {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 10px;
}

.section-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 3px;
  border-bottom: 1px solid #eee;
  padding-bottom: 2px;
}

/* Device Overview Section */
.device-overview .overview-content {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.device-overview .sales-card {
  width: 30%;
  background-color: #28a745; /* Green color from image */
  color: #fff;
  padding: 20px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.device-overview .sales-card .card-icon {
  width: 30px;
  height: 30px;
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  margin-bottom: 10px;
  text-align: center;
  line-height: 30px;
  font-size: 20px;
  display: inline-block;
}

.device-overview .sales-card .card-text {
  font-size: 14px;
  opacity: 0.8;
  font-weight: bold;
  font-size: 18px;
  color: #ffffff;
}

.device-overview .sales-card .card-value {
  font-size: 32px;
  font-weight: bold;
  margin-top: 5px;
  /* text-align: center; */
}

.device-overview .sales-card .card-growth {
  font-size: 16px;
  margin-top: 5px;
  /* text-align: center; */
}

.device-overview .sales-card .card-footer {
  font-size: 14px;
  margin-top: 15px;
  padding-top: 10px;
  border-top: 1px solid rgba(255, 255, 255, 0.3);
}

.device-overview .right-overview-cards {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(4, 1fr); /* 每行3列，每列宽度相等 */
  grid-template-rows: repeat(2, auto); /* 两行，行高自动 */
  gap: 10px; /* 可选：设置网格项之间的间隔 */
}

.device-overview .small-card {
  background-color: #f8f9fa; /* Light background for small cards */
  color: #333;
  padding: 15px;
  border-radius: 8px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}
.bold-text {
  font-weight: bold;
  font-size: 16px;
}
.WorkOrder-card .right-overview-cards {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* 每行3列，每列宽度相等 */
  grid-template-rows: repeat(1, auto); /* 两行，行高自动 */
  gap: 10px; /* 可选：设置网格项之间的间隔 */
}
.WorkOrder-card .right-overview-cards4 {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(4, 1fr); /* 每行3列，每列宽度相等 */
  grid-template-rows: repeat(1, auto); /* 两行，行高自动 */
  gap: 10px; /* 可选：设置网格项之间的间隔 */
}
.WorkOrder-card .small-card {
  background-color: #f8f9fa; /* Light background for small cards */
  color: #333;
  padding: 15px;
  border-radius: 8px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  .card-icon {
    width: 20px;
    height: 20px;
    background-color: #ccc;
    border-radius: 50%;
    margin: 0 auto 5px;
  }
  .card-text {
    font-size: 12px;
    width: 100%;
    color: #666;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .card-value {
    font-size: 24px;
    font-weight: bold;
    width: 100%;
    margin-top: 5px;
  }
}
.device-overview .small-card .card-icon {
  width: 20px;
  height: 20px;
  background-color: #ccc;
  border-radius: 50%;
  margin: 0 auto 5px;
}

.device-overview .small-card .card-text {
  font-size: 12px;
  width: 100%;
  color: #666;
  display: flex;
  align-items: center;
  justify-content: center;
}

.device-overview .small-card .card-value {
  font-size: 24px;
  font-weight: bold;
  width: 100%;
  margin-top: 5px;
}

/* Operational Status Section */
.operational-status .status-content {
  display: flex;
  gap: 20px;
  height: 215px; /* Adjust height as needed for charts */
}

.operational-status .chart-container-right {
  width: 40%;
  height: 100%;
}
.chart-container-left {
  width: 60%;
  height: 100%;
}

.operational-status .sub-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
}

.operational-status ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.operational-status li {
  margin-bottom: 5px;
  font-size: 14px;
}

.operational-status .fault-items span {
  display: inline-block;
  background-color: #e9ecef;
  padding: 5px 10px;
  border-radius: 5px;
  margin-right: 10px;
  font-size: 14px;
}

.operational-status .pie-chart-placeholder {
  flex: 1;
  border: 1px dashed #ccc;
  min-height: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #999;
}

/* Inspection and Maintenance Section */
.inspection-maintenance .el-tabs__content {
  height: 250px; /* 根据图表高度调整 */
  padding: 20px 0;
}

.inspection-maintenance .tab-chart-container {
  width: 100%;
  height: 350px;
}

.inspection-maintenance .im-content {
  display: flex;
  gap: 20px;
  align-items: flex-start;
}

.inspection-maintenance .inspection-section,
.inspection-maintenance .maintenance-section {
  flex: 1;
}

.inspection-maintenance ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.inspection-maintenance li {
  margin-bottom: 8px;
  font-size: 14px;
  color: #555;
}

.inspection-maintenance li span {
  color: #333;
  font-weight: normal;
}

.inspection-maintenance .bar-chart-placeholder {
  flex: 1;
  border: 1px dashed #ccc;
  min-height: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #999;
}

/* Cost Overview Section */
.cost-overview .cost-details {
  display: flex;
  flex-direction: column;
}

.cost-overview .sales-yoy {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-bottom: 20px;
}

.cost-overview .sales-yoy .item {
  background-color: #f8f9fa;
  color: #333;
  padding: 15px;
  border-radius: 8px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.cost-overview .sales-yoy .item .value {
  font-size: 22px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: #333;
  margin-top: 5px;
}

.cost-overview .sales-yoy .item .label {
  font-size: 12px;
  color: #666;
  width: 100%;
  margin-top: 5px;
}

.cost-overview .category-list .category-item {
  display: flex;
  align-items: center;
  margin-top: 25px;
  margin-bottom: 25px;
  height: 50px;
  gap: 10px;
}

.cost-overview .category-item .rank {
  width: 25px;
  height: 25px;
  background-color: #007bff;
  color: #fff;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  flex-shrink: 0;
}

.cost-overview .category-item .name {
  font-size: 14px;
  color: #333;

  width: 100px;
  flex-shrink: 0;
}

.cost-overview .category-item .progress-container {
  flex: 1;
  height: 20px;
  background-color: #f0f0f0;
  border-radius: 4px;
  overflow: hidden;
  margin: 0 10px;
}

.cost-overview .category-item .progress-bar {
  height: 100%;
  background: linear-gradient(to right, #28a745, #ffc107);
  border-radius: 4px;
  transition: width 0.3s ease;
}

.cost-overview .category-item .value {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  width: 80px;
  text-align: right;
  flex-shrink: 0;
}

::v-deep .el-card {
  .el-card__body {
    padding: 0;
    height: 100%;
    width: 100%;
  }
}
.card-Table-List {
  // display: flex;
  // flex-wrap: wrap;
  // gap: 5px;
}
::v-deep .el-tabs {
  width: 100%;
  .el-tabs__content {
    width: 100%;
    .el-tab-pane {
      width: 100%;
    }
  }
}
.projectInfo {
  // position: absolute;
  // bottom: 0;
  // left: 0;
  width: 100%;
  height: 40px;
  // background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;

  padding: 0 10px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: bold;
}
::v-deep .divider {
  height: auto;
}
.ec {
  position: absolute;
  right: -13px;
  top: 13px;
  z-index: 11;
  height: 220px;
}
</style>
